<template>
    <modal @close="$emit('close')" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('carrello_sel_ind_title')}}</h5>
        </div>
        <div slot="body">
            {{$t('carrello_sel_ind_label')}}:<br><br>
            <ul class="lista_indirizzi">
                <li v-for="(address, i) in this.available_addresses">
                    <mcw-radio v-model="selected_address" name="address" :id="'address_'+i"
                               :label="getAdressDescription(address)" :value="address.id.toString()"/>
                </li>
            </ul>
            <div v-if="this.unavailable_addresses.length" class="mt-4">
                <b>{{this.$t('indirizzi_fuori_zona')}}</b>
                <ul class="lista_indirizzi">
                    <li v-for="(address, i) in this.unavailable_addresses">
                        <mcw-radio v-model="selected_address" name="address" :id="'address_'+i" disabled
                                   :label="getAdressDescription(address)" :value="address.id.toString()"/>
                    </li>
                </ul>
            </div>
        </div>
        <div slot="footer" class="d-flex flex-fill justify-content-between">
            <button type="button" class="btn btn-default" @click="$emit('close')">
                {{$t('btn_annulla')}}
            </button>
            <button type="button" class="btn btn-primary" @click="$emit('close', parseInt(selected_address))">
                {{$t('btn_conferma')}}
            </button>
        </div>
    </modal>
</template>

<script>
import Modal from '../../partials/Modal';
import {mapState} from "vuex";
import {trovaConsegnaCitta} from "../../../libraries/utils";

export default {
    name: "ModalSelectAddress",
    components: {Modal},
    props: ['addresses', 'currentAddress', 'orderAddress', 'deliveryConfiguration'],
    data() {
        return {
            selected_address: this.currentAddress ? this.currentAddress.id.toString() : null
        }
    },
    computed: {
        available_addresses: function () {
            if (this.deliveryConfiguration.f_modalita_fasce_zona) {
                return this.addresses.filter((address) => {
                    if (this.orderAddress) {
                        const cond1 = address.id_consegna_citta === this.orderAddress.id_consegna_citta;
                        const cond2 = this.orderAddress.id_consegna_zona ?
                            address.id_consegna_zona === this.orderAddress.id_consegna_zona : true;
                        return cond1 && cond2;
                    }

                    return true;
                });
            } else if (this.f_distretto && this.deliveryConfiguration.tipo_modalita_zone === 'COORDINATE') {
                const consegneCitta = this.addresses.map((address) => {
                    return {
                        ...address.consegna_citta,
                        coordinate: JSON.parse(address.consegna_citta.coordinate),
                    };
                });

              if (this.orderAddress) {
                return this.addresses.filter((address) => {
                  const consegnaCitta = trovaConsegnaCitta(
                      consegneCitta,
                      address.longitudine,
                      address.latitudine,
                  );

                  return !!consegnaCitta;
                });
              }
            }

            return this.addresses;
        },
        unavailable_addresses: function () {
            return this.addresses.filter((address) => {
                return !this.available_addresses.map((available_address) => available_address.id).includes(address.id);
            });
        },
        ...mapState('restaurant', {
            f_distretto: state => state.f_distretto
        })
    },
    methods: {
        getAdressDescription: function (address) {
            return address.indirizzo + ', ' + address.numero +
                (address.localita_citta ? ' - ' + address.localita_citta + (address.cap_citta ? ' ' + address.cap_citta : '') : '') +
                (address.localita_zona ? ' - ' + this.$t('zona') + ': ' + address.localita_zona + (address.cap_zona ? ' ' + address.cap_zona : '') : '') +
                (address.provincia ? ' (' + address.provincia + ')' : '')
        }
    }
}
</script>
